module.exports = __webpack_public_path__ + "static/media/HackathonOrganizers.b71bd22e.png";